import { teamsEnv } from "../../core/utils";
import { composeRequestConfig, createRequest } from "../../core/utils/axios/api";

export const dismissAlert = async alert_id => {
  const url = `/api/v1/ms_teams/${teamsEnv.tenantId}/alerts/${alert_id}/dismiss`;

  const config = composeRequestConfig({ url, method: 'post' });
  return createRequest(config);
};